import { useState, useEffect } from "react";
import { Modal } from "antd";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { connect } from "react-redux";

import { Modals } from "scripts/settings";
import Resources from "scripts/resources";
import { GetUrlParams, ObjectToURL } from "scripts/helpers";

const Component = ({ categories = [] }) => {
	const initialState = {};
	const [state, setState] = useState(initialState);
	const { visible } = state;
	const location = useLocation();
	const navigate = useNavigate();
	const { category, coordinates, search } = GetUrlParams(location.search);
	const sortByQuery = ObjectToURL({ category, coordinates, search });

	const componentDidUpdate = () => {
		if (location.hash?.startsWith(`#${Modals.SORT}`)) {
			setState((prevState) => ({
				...prevState,
				visible: true,
			}));
		} else {
			setState(initialState);
		}
	};

	useEffect(componentDidUpdate, [location.hash]);

	return (
		<Modal
			className="bk-modal-sort"
			footer={false}
			maskClosable={false}
			onCancel={() => navigate(-1)}
			open={visible}
			width={500}
			destroyOnClose
			title={Resources.sort}
		>
			<ul className="list">
				<li>
					<Link
						to={`/jobs?${sortByQuery && `${sortByQuery}&`}sortBy=rating`}
					>{`${Resources.sort} ${Resources.on} ${Resources.basis} ${Resources.score} `}</Link>
				</li>
				<li>
					<Link
						to={`/jobs?${sortByQuery && `${sortByQuery}&`}sortBy=discount`}
					>{`${Resources.sort} ${Resources.on} ${Resources.basis} ${Resources.discount} `}</Link>
				</li>
			</ul>
		</Modal>
	);
};

export default connect((state) => {
	return {
		categories: state.categories,
	};
})(Component);
